import { useState, useEffect } from 'react';
import isClient, { cookiesEnabled } from '../../../common/helpers/environment';
import useFeatureToggle from '../useFeatureToggle';
import usePersistedFlag from './usePersistedFlag';

export const COOKIE_NAME = 'is_cookie_policy_accepted';

const useCookiePolicy = () => {
    const [isAccepted, setIsAccepted] = useState(true);
    const [status, setStatus] = usePersistedFlag(COOKIE_NAME);
    const featureToggles = useFeatureToggle();
    const isCookiePolicyEnabled = !!featureToggles.isDefaultCookieBannerEnabled;

    // Alice uses only local storage for the cookie policy check, hence we can never know the value
    // on the server, so we never show it there, Then on the client we can be sure we get
    // what is in Local storage or our cookie if we had set it before

    useEffect(() => {
        setIsAccepted(!isClient() || !!status || !cookiesEnabled);
    }, [status]);

    const acceptCookiePolicy = () => setStatus(1);
    const shouldShow = !isAccepted && isCookiePolicyEnabled;
    return { shouldShow, isAccepted, acceptCookiePolicy, isCookiePolicyEnabled };
};

export default useCookiePolicy;
